import { render, staticRenderFns } from "./go-to-class.vue?vue&type=template&id=6e7a3fc3"
import script from "./go-to-class.vue?vue&type=script&lang=js"
export * from "./go-to-class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports